export default function Header({ seats, cap }) {
  const scrollToLoadCheck = () => {
    if (window.__lenis) {
      window.__lenis.scrollTo("#load-check", { offset: -40 });
    } else {
      document.getElementById("load-check")?.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <header
      data-testid="site-header"
      className="fixed top-0 left-0 w-full z-50 backdrop-blur-md bg-background/80 border-b border-border/50"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 h-16 flex items-center justify-between gap-4">
        <a href="#top" data-testid="header-logo-link" className="flex items-center shrink-0">
          <img src="/the-keep-lockup.png" alt="The Keep" className="h-8 sm:h-9 w-auto" />
        </a>
        <div className="flex items-center gap-3 sm:gap-5">
          <span data-testid="seat-counter" className="hidden md:inline font-mono text-[11px] tracking-[0.2em] text-muted-foreground whitespace-nowrap">
            {seats !== null && seats >= 25 ? `${seats} / ${cap} SEATS CLAIMED · FREE` : `${cap} FOUNDING SEATS · FREE`}
          </span>
          <button
            data-testid="header-cta-button"
            onClick={scrollToLoadCheck}
            className="cta-gold font-mono text-[10px] sm:text-xs tracking-[0.15em] px-3.5 sm:px-5 py-2.5 whitespace-nowrap"
          >
            TELL US WHAT'S HARDEST
          </button>
        </div>
      </div>
    </header>
  );
}
